// FILE: /services/authConnect.js (FULLY CORRECTED)
import axiosServices from "./axios"; // <-- Keep only one import

// A map to centralize API endpoints for different platforms
const platformEndpoints = {
    FACEBOOK: {
        init: '/facebook/initiate-auth',
        callback: '/facebook/auth/callback',
        finalize: '/facebook/finalize-connection'
    },
    INSTAGRAM: {
        init: '/instagram/auth',
        callback: '/instagram/auth/callback',
        finalize: '/instagram/finalize-connection'
    },
    PINTEREST: {
        init: '/pinterest/auth',
        callback: '/pinterest/auth/callback',
        finalize: null
    },
    LINKEDIN: {
        init: '/linkedin/auth',
        callback: '/linkedin/callback',
        finalize: null 
    },
    // --- START: NEW PLATFORM DEFINITION ---
    LINKEDIN_BUSINESS: {
        init: '/linkedin/business/auth',
        callback: '/linkedin/business/callback',
        finalize: '/linkedin/business/finalize'
    },
    // --- END: NEW PLATFORM DEFINITION ---
    GMB: {
        init: '/gmb/auth/url',
        callback: '/gmb/auth/callback',
        finalize: '/gmb/locations/finalize'
    },
    YOUTUBE: {
        init: '/youtube/auth',
        callback: '/youtube/auth/callback',
        finalize: '/youtube/finalize'
    },
    TIKTOK: {
        init: '/tiktok/auth/url',
        callback: '/tiktok/auth/callback',
        finalize: null
    }
};

const handleApiError = (error, defaultMessage) => {
    if (error.response?.status === 403 && error.response?.data?.errorType === 'LIMIT_REACHED') {
        throw error;
    }
    if (error.response && error.response.data && error.response.data.message) {
        throw new Error(error.response.data.message);
    }
    throw new Error(defaultMessage);
};

export const getAuthUrl = async (platform, groupName, origin) => { 
    const upperPlatform = platform.toUpperCase();
    const endpoint = platformEndpoints[upperPlatform]?.init;
    if (!endpoint) throw new Error(`Unsupported platform: ${platform}`);

    try {
        const payload = { groupName, origin }; 
        const response = await axiosServices.post(endpoint, payload);
        return response.data;
    } catch (error) {
        handleApiError(error, `Could not get authentication URL for ${platform}.`);
    }
};

export const handleCallback = async (platform, code, state) => {
    const upperPlatform = platform.toUpperCase();
    const endpoint = platformEndpoints[upperPlatform]?.callback;
    if (!endpoint) throw new Error(`Unsupported platform: ${platform}`);

    try {
        const response = await axiosServices.get(endpoint, {
            params: { 
                code, 
                state
            } 
        });
        
        if (response.data.instagramAccounts || response.data.pagesList || response.data.locations || response.data.channels || response.data.organizations) {
            return { ...response.data, requiresSelection: true };
        }
        return { ...response.data, requiresSelection: false };
    } catch (error) {
        handleApiError(error, `Failed to process callback for ${platform}.`);
    }
};

export const finalize = async (platform, selectedItems, stateToken) => {
    const upperPlatform = platform.toUpperCase();
    const endpoint = platformEndpoints[upperPlatform]?.finalize;
    if (!endpoint) {
        return { success: true };
    }

    const payload = {
        FACEBOOK: { selectedPages: selectedItems, stateToken },
        INSTAGRAM: { selectedAccounts: selectedItems, stateToken },
        GMB: { selectedLocations: selectedItems, stateToken },
        YOUTUBE: { selectedChannels: selectedItems, stateToken },
        // --- START: NEW PAYLOAD DEFINITION ---
        LINKEDIN_BUSINESS: { selectedOrganizations: selectedItems, stateToken }
        // --- END: NEW PAYLOAD DEFINITION ---
    }[upperPlatform];
    
        
    try {
        const response = await axiosServices.post(endpoint, payload);

        if (response.status === 206) {
            return {
                success: true,
                partial: true,
                message: response.data.message
            };
        }
        return response.data;

    } catch (error) {
        handleApiError(error, `Failed to finalize connection for ${platform}.`);
    }
};